import { action } from 'typesafe-actions';
import { AnomalyInterface, AnomalyRow, AnomaliesTypes } from './types';

// List Anomalies
export const listAnomaliesRequest = (payload: { body?: object }) =>
  action(AnomaliesTypes.LIST_ANOMALIES_REQUEST, payload);
export const listAnomaliesSuccess = (payload: {
  anomalies: AnomalyInterface[];
  totalCount: number;
}) => action(AnomaliesTypes.LIST_ANOMALIES_SUCCESS, payload);
export const listAnomaliesFailure = () =>
  action(AnomaliesTypes.LIST_ANOMALIES_FAILURE);

// List Anomaly Users
export const listAnomalyUsersRequest = (payload: { id: string; body?: object }) =>
  action(AnomaliesTypes.LIST_ANOMALY_USERS_REQUEST, payload);
export const listAnomalyUsersSuccess = (payload: {
  anomalyUsers: AnomalyRow[];
}) => action(AnomaliesTypes.LIST_ANOMALY_USERS_SUCCESS, payload);
export const listAnomalyUsersFailure = () =>
  action(AnomaliesTypes.LIST_ANOMALY_USERS_FAILURE);
